"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _customPage = require("@/api/customPage");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: '',
  data: function data() {
    return {
      queryData: {
        title: '',
        page: {
          page: 1,
          size: 10
        }
      },
      pagination: {
        total: 0 // 条数
      },
      dataList: []
    };
  },
  created: function created() {
    this.pageListPage();
  },
  methods: {
    // 查询
    onInquire: function onInquire() {
      this.queryData.page.page = 1;
      this.queryData.page.size = 10;
      this.pageListPage();
    },
    // 初始化
    onInit: function onInit() {
      this.queryData = {
        title: '',
        page: {
          page: 1,
          size: 10
        }
      };
    },
    // 重置
    onInitialize: function onInitialize() {
      this.onInit();
      this.pageListPage();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.queryData.page.size = val;
      this.pageListPage();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.queryData.page.page = val;
      this.pageListPage();
    },
    // 选择
    onSelectEvents: function onSelectEvents(value) {
      console.log('data', value);
      var data = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, value), {}, {
        Display_type: 10,
        // 区分类型
        Display_name: '自定义页面' // 名字
      });
      this.$emit('SelectEvents', data);
    },
    // 列表
    pageListPage: function () {
      var _pageListPage = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var params, res, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              params = {
                page: this.queryData.page.page,
                size: this.queryData.page.size,
                name: this.queryData.title
              };
              _context.n = 1;
              return (0, _customPage.getList)(params);
            case 1:
              res = _context.v;
              if (res.code === 0) {
                this.dataList = res.data.data;
                this.pagination.total = res.data.total;
              }
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.log(_t);
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function pageListPage() {
        return _pageListPage.apply(this, arguments);
      }
      return pageListPage;
    }()
  }
};